import ButtonIcon from "#common/buttons/ButtonIcon"
import { MasterDialog } from "#common/Dialog/Dialog"
import { formatMoney } from "#common/Funciones"
// import InfoOutlineIcon from "@mui/icons-material/InfoOutline"
import { DataItem } from "#common/text/DataItem"
import InfoIcon from "@mui/icons-material/Info"
import { Divider } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useState } from "react"
const TableInfoDialog = ({ data, currency }) => {
	const [open, setOpen] = useState(false)
	const colaborador = {
		// numero_x: "INDEX TABLA EXCEL",
		nombre: "NOMBRE",
		sucursal: "SUCURSAL",
		perfil_puesto: "PERFIL PUESTO",
		cuenta: "CUENTA",
	}
	const laborador = {
		precio_hora: "PRECIO POR HORA",
		salario_diario: "SALARIO DIARIO",
		dias_laborados: "DIAS LABORADOS",
		salario_semanal: "SALARIO SEMANAL",
		hrs_extra: "HORAS EXTRA",
		antiguedad: "ANTIGÜEDAD",
		destajo: "DESTAJO",
		vacaciones_prima: "VAC + PRIMA VACACIONAL",
	}
	const deducciones = {
		faltas: "FALTAS",
		deducciones_faltas: "DEDUCCIONES FALTAS",
		deducciones_bancaria: "DEDUCCIÓN BANCARIA",
		deducciones_prestamo: "DEDUCCIONES PRESTAMO",
		deducciones_saldo_a_favor: "DEDUCCIONES SALDO A FAVOR",
		deducciones_creditos_infonavit_fonacot: "CRÉDITOS INFONAVIT / FONACOT",
	}
	const final = {
		observaciones: "OBSERVACIONES",
		extras: "EXTRAS",
		observaciones_extras: "OBSERVACIONES EXTRAS",
		total_neto: "TOTAL NETO",
	}

	const no_money = [
		"numero_x",
		"nombre",
		"sucursal",
		"perfil_puesto",
		"cuenta",
		"extras",
		"faltas",
		"observaciones",
		"dias_laborados",
		"observaciones_extras",
	]
	const list_info = (list) => {
		return Object.keys(list).map((key) => {
			let value = data[key]
			if (value == null) value = "N/A"
			else {
				if (!no_money.includes(key)) value = formatMoney(value, currency)
			}

			return (
				<Grid2 key={key} xs={3}>
					<DataItem label={list[key]} value={value} />
				</Grid2>
			)
		})
	}

	return (
		<>
			<ButtonIcon
				title="Información"
				icon={<InfoIcon />}
				onClick={() => setOpen(true)}
			/>
			<MasterDialog
				maxWidth="lg"
				title={"Recibo de nómina"}
				{...{
					open,
					setOpen,
				}}
			>
				<Grid2 container spacing={2}>
					{/*<Grid2 xs={12}>
						<Divider textAlign="left">Colaborador</Divider>
					</Grid2>*/}
					{list_info(colaborador)}
					<Grid2 xs={12}>
						<Divider textAlign="left">Percepciones</Divider>
					</Grid2>
					{list_info(laborador)}
					<Grid2 xs={12}>
						<Divider textAlign="left">Deducciones</Divider>
					</Grid2>
					{list_info(deducciones)}
					<Grid2 xs={12}>
						<Divider textAlign="left">Totales</Divider>
					</Grid2>
					{list_info(final)}
				</Grid2>
			</MasterDialog>
		</>
	)
}
export default TableInfoDialog
const text = {
	nombre: "NOMBRE",
	sucursal: "SUCURSAL",
	perfil_puesto: "PERFIL PUESTO",
	cuenta: "CUENTA",
	bonos: "BONOS",
	extras: "EXTRAS",
	faltas: "FALTAS",
	destajo: "DESTAJO",
	hrs_extra: "HORAS EXTRA",
	antiguedad: "ANTIGÜEDAD",
	precio_hora: "PRECIO POR HORA",
	observaciones: "OBSERVACIONES",
	dias_laborados: "DIAS LABORADOS",
	salario_diario: "SALARIO DIARIO",
	salario_semanal: "SALARIO SEMANAL",
	vacaciones_prima: "VAC + PRIMA VACACIONAL",
	deducciones_faltas: "DEDUCCIONES FALTAS",
	deducciones_bancaria: "DEDUCCIÓN BANCARIA",
	deducciones_prestamo: "DEDUCCIONES PRESTAMO",
	observaciones_extras: "OBSERVACIONES EXTRAS",
	deducciones_saldo_a_favor: "DEDUCCIONES SALDO A FAVOR",
	deducciones_creditos_infonavit_fonacot: "CRÉDITOS INFONAVIT / FONACOT",
	total_neto: "TOTAL NETO",
}
